import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-umber text-cream/70">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-6 py-16 sm:grid-cols-4 sm:px-12">
        <div className="sm:col-span-2">
          <div className="flex items-center gap-2 font-display text-xl text-cream">
            <span className="grid h-8 w-8 place-items-center rounded-md bg-terracotta text-cream">S</span>
            SeedTech<span className="text-gold">NG</span>
          </div>
          <p className="mt-4 max-w-sm text-sm text-cream/60">
            Helping African businesses raise grants and venture funding on international standards.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-cream/40">Sitemap</div>
          <ul className="mt-3 space-y-2 text-sm">
            <li><a href="#services" className="hover:text-cream">Services</a></li>
            <li><a href="#how-it-works" className="hover:text-cream">How it works</a></li>
            <li><a href="#pricing" className="hover:text-cream">Pricing</a></li>
            <li><a href="#faq" className="hover:text-cream">FAQ</a></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-cream/40">Contact</div>
          <ul className="mt-3 space-y-2 text-sm">
            <li><a href="mailto:hello@seeds.com3.ng" className="hover:text-cream">hello@seeds.com3.ng</a></li>
            <li><a href="https://seeds.com3.ng" className="hover:text-cream">seeds.com3.ng</a></li>
            <li>Lagos · Nairobi · Accra</li>
            <li>
              <Link to="/admin/login" data-testid="footer-staff-link" className="text-cream/40 hover:text-cream">
                Staff login →
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-cream/10 px-6 py-5 text-center text-xs text-cream/40 sm:px-12">
        © {new Date().getFullYear()} SeedTechNG. All rights reserved.
      </div>
    </footer>
  );
}
